/************************************************************
 Physiotherapy Plan
 ************************************************************/

window.physiotherapyPlanNS = {
    _action:null,
    _callback:null,
    _row:null,
    // Execute Action
    executeAction:function (action, row, callback) {
        var wfId = parseInt(action.wf_id),
            actionId = parseInt(action.wf_action_id);

        this._action = action;
        this._callback = callback;
        this._row = row;

        // Cancel Plan
        if (actionId == 3) {
            physiotherapyPlanNS.cancelPlan();
        }
        // Discontinue Plan
        else if (actionId == 8) {
            physiotherapyPlanNS.discontinuePlan();
        }
        // Other actions
        else {
            physiotherapyPlanNS.executeGenericAction();
        }
    },
    // Execute Generic Action
    executeGenericAction:function () {
        workflow.executeAction(physiotherapyPlanNS._action, physiotherapyPlanNS._callback, physiotherapyPlanNS._row);
    },
    cancelPlan:function () {
        var params = {task_id:physiotherapyPlanNS._action.task_id};

        $.post('/physiotherapy/cancel_physiotherapy_plan', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapyPlanNS._callback(false, physiotherapyPlanNS._action, physiotherapyPlanNS._row);
                } else {
                    physiotherapyPlanNS._callback(true, physiotherapyPlanNS._action, physiotherapyPlanNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapyPlanNS._callback(false, physiotherapyPlanNS._action, physiotherapyPlanNS._row);
            });
    },
    discontinuePlan:function () {
        var params = {task_id:physiotherapyPlanNS._action.task_id};

        $.post('/physiotherapy/discontinue_physiotherapy_plan', params, null, 'json')
            .done(function (data, status, xhr) {
                Hades.checkIfUserIsAuthorized(data, status, xhr);

                if (data.success != true) {
                    Hades.showError(Hades.genericErrorMsg(), data.error);
                    Hades.hideLoading();
                    physiotherapyPlanNS._callback(false, physiotherapyPlanNS._action, physiotherapyPlanNS._row);
                } else {
                    physiotherapyPlanNS._callback(true, physiotherapyPlanNS._action, physiotherapyPlanNS._row);
                }
            })
            .fail(function (xhr, status, error) {
                Hades.showError(error, xhr.responseText, xhr, status, error);
                Hades.hideLoading();
                physiotherapyPlanNS._callback(false, physiotherapyPlanNS._action, physiotherapyPlanNS._row);
            });
    }
};